import React from "react";

export default function FadeInSection(props) {
    return (
        <div class="animate__animated animate__fadeIn">
            A software engineer at{" "}
            <a href="https://www.microsoft.com/en-us/"> Microsoft</a>
        </div>
    );
}